
document.addEventListener('DOMContentLoaded', function(event) {

    const ajaxUrl = window.location.origin + '/wp-admin/admin-ajax.php';

    /**
	 * Load background video on dom load
	 */
	const pageHeaderBlocks = document.querySelectorAll('.wp-block-crown-blocks-media-header');
	pageHeaderBlocks.forEach( (block, index) => {

        const bg_video = block.querySelector('.bg-video');
        if ( ! bg_video ) return;
        
        const videoUrl = bg_video.getAttribute('data-video-url');
        if ( (typeof videoUrl === 'undefined' || videoUrl == '') ) return;
        const mimeType = bg_video.getAttribute('data-mime-type');
        
        bg_video.innerHTML += '<video muted loop><source src="' + videoUrl + '" type="' + mimeType + '" /></video>';
        setTimeout(() => {
            bg_video.querySelector('video').play();
        }, 100);
        
	});
    
});
